import { useState } from 'react';
import './Login.scss';
import { useLocation, useNavigate } from 'react-router';
import Account from '../../api/controllers/Account/Account';
import useToken from '../../hooks/useToken/useToken';
import Input from '../../common/Input/Input';
import FreightsoftLogo from '../../assets/FreightsoftLogo.png';
import Button from '../../common/Button/Button';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState();
  const [formDisabled, setFormDisabled] = useState(false);

  const { setToken } = useToken();
  const navigate = useNavigate();
  const location = useLocation();

  const prevURL = location.state;

  const login = e => {
    setFormDisabled(true);
    e.preventDefault();
    e.stopPropagation();
    Account.logIn(username, password)
      .then(({ token, currentHubId, lastSignInAt, firstName, lastName }) => {
        setToken(token);
        localStorage.setItem(
          'user',
          JSON.stringify({
            name: `${firstName} ${lastName}`,
            currentHubId: currentHubId,
            lastSignInAt: lastSignInAt,
          }),
        );
        setTimeout(() => {
          navigate(prevURL ? prevURL : '/');
        }, 100);
      })
      .catch(e => {
        setError(e.errors || e.error);
        setFormDisabled(false);
      });
  };

  return (
    <div className="login_screen">
      <div className="login_container">
        <img src={FreightsoftLogo} data-testid="freightsoft_logo" className="logo" />
        <div className="form">
          <form className={`content ${formDisabled && 'disableForm'}`} onSubmit={login}>
            <Input
              placeholder="Username"
              autofocus={true}
              value={username}
              setValue={setUsername}
              disabled={formDisabled}
            />
            <Input
              placeholder="Password"
              type="password"
              value={password}
              setValue={setPassword}
              disabled={formDisabled}
            />
            {error && (
              <>
                {Array.isArray(error) ? (
                  <>
                    <div className="error_title">
                      {error.length} error{error.length > 1 ? 's' : ''} occurred:
                    </div>
                    {error.map((errorMessage, i) => {
                      return (
                        <div key={i} className={`error_message shifted`}>
                          <span className="bulletpoint">{'•'}</span>
                          {errorMessage.split('[')[0]}
                        </div>
                      );
                    })}
                  </>
                ) : (
                  <div className={`error_message`}>{error}</div>
                )}
              </>
            )}
            <Button
              className="login_button"
              type="submit"
              disabled={formDisabled}
              data-testid="login_button"
              label={'Log In'}
            />
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
